
import {share, mergeMap, map} from 'rxjs/operators';
import {Injectable, NgZone} from '@angular/core';
import {User} from './user';
import {Router} from "@angular/router";
import {Observable} from "rxjs";
import {ToastrService} from "ngx-toastr";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {Util} from "../common/util";
import {CustomQueryEncoderHelper} from "./CustomQueryEncoderHelper";
import { HybridToolsService } from '../core/services/hybrid-tools.service';

@Injectable()
export class AuthenticationService {
    public token: string;
    public storage;
    public user: any;
    private targetUser: string;

    constructor(
        private http: HttpClient,
        private router: Router,
        private zone: NgZone,
        private hybridToolsService: HybridToolsService,
        private toastr: ToastrService
    ) {
        this.storage = sessionStorage;
    }

    setTargetUser(username: string) {
        this.targetUser = username;
    }

    sudoer() {
        return JSON.parse(this.storage.getItem('sudoer'));
    }

    socialLogin(socialResponse) {
        return this.processAfterLogin(this.http.post('/api/v2/auth/social', socialResponse), false);
    }

    login(username: string, password: string, rememberMe: boolean): Observable<Object> {
        var params = new HttpParams({ encoder: new CustomQueryEncoderHelper() })
            .append('username', username)
            .append('password', password);
        return this.processAfterLogin(this.http.post('/api/v1/auth/login', params), rememberMe);
    }

    processAfterLogin(obs: Observable<Object>, rememberMe: boolean) {
        // Is this next section of code seriously how this is done? Seems rather insane.
        return obs.pipe(map(res => {
                this.token = res['access_token'];
                return res;
            }),
            mergeMap(() => {
                // Provide authorization explicitly, since it is not set yet
                return this.http.get('/api/v1/user', {
                    headers: new HttpHeaders()
                        .set('Authorization', 'Bearer ' + this.token)
                });
            }),
            map(user => {
                user['isAdmin'] = !!user['authorities'].find(o => {
                    return o.authority === 'ROLE_ADMIN';
                });
                user['accessToken'] = this.token;
                this.storage.setItem('currentUser', JSON.stringify(user));
                if (rememberMe) localStorage.setItem("currentUser", JSON.stringify(user));
                this.user = user;
                return this.user;
            }));
    }

    setToken(accessToken) {
        this.token = accessToken;
        let user = this.currentUser();
        user['accessToken'] = this.token;
        this.storage.setItem('currentUser', JSON.stringify(user));
        if (localStorage.getItem('currentUser')) localStorage.setItem("currentUser", JSON.stringify(user));
        this.user = user;
    }

    isImpersonating() {
        return !!this.storage.getItem('sudoer');
    }

    stopImpersonating() {
        if (this.storage.getItem('sudoer') == null) return;
        sessionStorage.removeItem('sudoer');
        sessionStorage.removeItem("hasValidAdminPassword");
    }

    currentUser(): User {
        // Check if there is an impersonation request.
        var targetUserParam = Util.getParameterByName("targetUser");
        if (targetUserParam) {
            this.targetUser = targetUserParam;
            // End any previous impersonation before we try to impersonate the next user.
            this.stopImpersonating();
        }

        if (this.user && this.targetUser == null) return this.user;
        this.user = JSON.parse(this.storage.getItem('currentUser'));
        if (this.user == null) {
            this.user = JSON.parse(localStorage.getItem('currentUser'));
            if (this.user != null) this.storage.setItem("currentUser", JSON.stringify(this.user));
        }

        return this.user;
    }

    logout(): void {
        this.http.post('/api/v1/auth/logout', {})
            .subscribe(
                response => {
                    this.clearUserState();
                    // This will reload the page and clean all states
                    this.hybridToolsService.hardReload();
                },
                error => {
                    this.clearUserState();
                    console.log(error);
                    this.hybridToolsService.hardReload();
                }
            );
    }

	//clearing the user state should be called after we logout from the backend, otherwise the backend doesn't know who we are
	clearUserState(): void {

		//localStorage.removeItem('org.lls.lastevent');
		sessionStorage.removeItem("currentUser");

		if (this.isImpersonating()) {
			this.stopImpersonating();
		} else {
			this.user = null;
			// clear token remove user from local storage to fully log user out
			localStorage.removeItem("currentUser");
		}
	}

	getCrowdToken() {
		return this.http.get('/api/v1/auth/crowdToken');
	}
}
